import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      component: () => import('./modules/login/Login.vue')
    },
    {
      path: '/',
      component: () => import('./layout/Layout.vue'),
      children: [
        {
          path: '/dashboard',
          name: 'dashboard',
          component: () => import('./modules/dashboard/Dashboard.vue')
        },
        {
          path: '/clientes',
          name: 'clientes',
          component: () => import('./modules/clientes/Clientes.vue')
        },
        {
          path: '/imoveis',
          name: 'imoveis',
          component: () => import('./modules/imoveis/Imoveis.vue')
        },
        {
          path: '/vendas',
          name: 'vendas',
          component: () => import('./modules/vendas/Vendas.vue')
          
        }
      ]
    },
  ]
})
